export const paymentMethods = [
    { text: 'Dinheiro', value: 'money' },
    { text: 'Cartão', value: 'card' },
    { text: 'Outros', value: 'others' },
];